import { LocalStorageTokens } from 'app/hooks/useFetchProcoreAuthToken';
import { PROCORE_TOKENS_KEY } from 'app/pages/store/procoreSlice';
import { useMemo } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export function useProcoreIntegration() {
  const [tokens] = useLocalStorage<LocalStorageTokens>(PROCORE_TOKENS_KEY, {
    accessToken: '',
    refreshToken: '',
  });

  const PROCORE_URL = `${process.env.REACT_APP_PROCORE_SIGN_IN_URL}`;

  const loading = useMemo(() => {
    const url = new URL(window.location.href);
    const codeParams = url.searchParams.getAll('procore_code');
    // If there are multiple 'code' parameters, set the URL to keep only the last one.
    if (codeParams.length > 1) {
      // Remove all 'procore_code' parameters first
      url.searchParams.delete('procore_code');
      // Then add back only the last one
      url.searchParams.append('procore_code', codeParams[codeParams.length - 1]);

      // Update the URL without reloading the page
      window.history.replaceState(null, '', url.toString());
    }

    // Return loading state based on the code and tokens
    return codeParams.length > 0 && !tokens.accessToken && !tokens.refreshToken;
  }, [tokens]);

  const connected = useMemo(() => Boolean(tokens.accessToken && tokens.refreshToken), [tokens]);

  return {
    tokens,
    loading,
    connected,
    procoreUrl: PROCORE_URL,
  };
}
